module.exports = __webpack_public_path__ + "static/media/Tammete_RDA.eb782cc9.png";